import { makeStyles } from "@material-ui/core/styles"
import { colors } from "./theme"

export const CONTAINER_MAX_WIDTH = "lg"

export default makeStyles(
  (theme) => ({
    title: {
      textAlign: "center",
      textTransform: "uppercase"
    },
    subtitle: {
      textTransform: "uppercase",
      marginBottom: theme.spacing(2)
    },
    margin2: {
      marginTop: theme.spacing(2)
    },
    margin3: {
      marginTop: theme.spacing(3)
    },
    margin4: {
      marginTop: theme.spacing(4)
    },
    margin10: {
      marginTop: theme.spacing(10)
    },
    large: {
      width: theme.spacing(12),
      height: theme.spacing(12)
    },
    marginAuto: {
      margin: "auto"
    },
    contrastButton: {
      color: colors.white,
      border: `solid 1px ${colors.white}`,
      "&:hover": {
        color: colors.white,
        borderColor: colors.orange,
        backgroundColor: colors.orange,
        transition: "color 0.2s linear"
      }
    },
    fixButtonSize: {
      margin: "auto",
      [theme.breakpoints.up("xs")]: {
        minWidth: "100%",
        "& > button, & > a": {
          minWidth: "98%",
          width: "98%"
        }
      },
      [theme.breakpoints.up("sm")]: {
        minWidth: "50%",
        "& > button, & > a": {
          minWidth: "98%",
          width: "98%"
        }
      },
      [theme.breakpoints.up("md")]: {
        minWidth: "50%",
        "& > button, & > a": {
          minWidth: "46%",
          width: "46%"
        }
      }
    },
    tableDataSection: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    section: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4)
    },
    sectionContainer: {
      // add all child same spacing between
      "& > *": {
        marginBottom: theme.spacing(2)
      }
    },
    sectionAvatarFilesContainer: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column"
      }
    },
    sectionAvatarContainer: {
      display: "flex",
      justifyContent: "space-around",
      [theme.breakpoints.up("xs")]: {
        minWidth: "100%"
      },
      [theme.breakpoints.up("sm")]: {
        minWidth: "50%"
      }
    },
    avatarContainer: {
      marginTop: theme.spacing(3),
      // add all child same spacing between
      "& > *": {
        marginBottom: theme.spacing(2)
      }
    },
    avatar: {
      borderRadius: "2%",
      margin: "auto",
      marginBottom: theme.spacing(2),
      width: "166px",
      height: "166px",
      [theme.breakpoints.up("xs")]: {
        width: "4rem",
        height: "4rem"
      },
      [theme.breakpoints.up("sm")]: {
        width: "6rem",
        height: "6rem"
      },
      [theme.breakpoints.up("md")]: {
        width: "8rem",
        height: "8rem"
      }
    },
    fundShareSelectorSection: {
      backgroundColor: colors.darkBlue
    },
    fundShareSelectorSectionTitle: {},
    fundShareSelectorSectionContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    fundShareSelectorButtons: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "center",
      flexDirection: "row",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column"
      }
    },
    fundShareVerticalSelector: {
      height: "270px"
    },
    fundShareOverview: {
      backgroundColor: colors.orange
    },
    fundShareOverviewContent: {
      display: "flex",
      justifyContent: "space-between",
      alignContent: "center"
    },
    fundShareOverviewBox: {
      width: "50%",
      padding: theme.spacing(3),
      margin: "auto",
      display: "flex",
      justifyContent: "center"
    },
    nav: {
      color: theme.palette.primary.main,
      fontSize: "4.4rem",
      padding: "0 0 0 11px",
      lineHeight: "0.86",
      textAlign: "center",
      display: "inline-block",
      borderBottom: "5px solid white",
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.up("xs")]: {
        fontSize: "1.4rem"
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: "2.6rem"
      },
      [theme.breakpoints.up("md")]: {
        fontSize: "3.6rem"
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: "4.4rem"
      }
    },
    fundCardRiskDescription: {
      flexGrow: 1
    },
    fundCardButton: {
      color: colors.orange,
      paddingUp: theme.spacing(2),
      paddingDown: theme.spacing(2),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
      textTransform: "none"
    },
    fundCardButtonSelected: {
      color: colors.white,
      backgroundColor: colors.orange,
      paddingUp: theme.spacing(2),
      paddingDown: theme.spacing(2),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
      textTransform: "none"
    },
    fundPerformances: {
      backgroundColor: colors.white
    },
    fundCharacteristics: {
      backgroundColor: colors.white3
    },
    fundCharacteristicsValueLabel: {
      textAlign: "right",
      fontWeight: "bold"
    },
    fundCharacteristicsValueText: {
      textAlign: "left",
      maxWidth: theme.spacing(56),
      paddingLeft: theme.spacing(3)
    },
    tab: {
      border: "1px solid",
      borderRadius: "5px",
      opacity: "1"
    },
    tabSelected: {
      border: "none",
      borderRadius: "5px",
      opacity: "1",
      color: colors.white,
      backgroundColor: colors.orange
    },
    fundRiskDivider: {
      width: "100%",
      height: 2,
      backgroundColor: "#ec6608",
      marginBottom: 20
    },
    fundRiskText: {
      maxWidth: 300,
      fontSize: 13,
      color: colors.darkBlue,
      lineHeight: 1.5
    },
    fundOpenCard: {
      height: theme.spacing(14)
    },
    fundOpenCardValueText: {
      fontSize: 12,
      color: colors.white,
      textTransform: "uppercase"
    },
    fundOpenCardIcon: {
      height: theme.spacing(3),
      objectFit: "contain",
      objectPosition: "center left",
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(3)
    },
    fundCardIconFill: {
      fill: colors.orange
    },
    fundOpenCardLabel: {
      fontSize: 18,
      fontWeight: "bold",
      color: colors.darkBlue,
      maxWidth: "70%"
    },
    fundOpenCardButtonText: {
      fontSize: 12,
      textTransform: "none",
      color: colors.white
    },
    fundSummaryTitle: {
      fontSize: 20,
      fontWeight: "bold",
      backgroundColor: "transparent",
      color: colors.greyDark
    },
    fundSummaryDescription: {
      fontSize: 16,
      fontWeight: "bold",
      backgroundColor: "transparent",
      color: colors.greyMedium
    }
  }),
  { index: 1 }
)
